
import { defineComponent, reactive, computed, toRefs } from 'vue'
import StatChart from '@/components/stat-chart/StatChart.vue'
import { useStore } from "@/store";
import {
  GetterConstants as HouseTypeGetterConstants,
  ActionConstants as HouseTypeActionConstants,
} from "@/store/modules/house-type/constants";
import { HouseTypeChartSourceClass } from "@/store/modules/house-type/state";
import { AppActionTypes } from '@/store/modules/app/action-types'
import { QueryParams } from '@/store/modules/app/state'

export default defineComponent({
  name: "HouseTypeStat",

  components: {
    StatChart
  },

  setup () {
    const store = useStore();

    const dataMap = reactive({
      fetching: computed(() => store.state.houseType.status.fetching),
      queryType: computed(() => store.state.app.queryType),
      statType: computed(() => store.state.app.statType),
      dataset: {
        dimensions: Object.keys(new HouseTypeChartSourceClass()).filter(item => item != "更新时间"),
        source: computed((): HouseTypeChartSourceClass[] => store.getters[HouseTypeGetterConstants.GET_HOUSE_TYPE_CHART_SOURCE](dataMap.queryType))
      },
      queryData (param: QueryParams) {
        store.dispatch(HouseTypeActionConstants.HOUSE_TYPE_FETCH, param);
      },
      queryTypeChange (queryType: string) {
        dataMap.queryType = queryType;
        store.dispatch(AppActionTypes.ACTION_QUERY_TYPE, queryType);
      },
      statTypeChange (statType: string) {
        dataMap.statType = statType;
        store.dispatch(AppActionTypes.ACTION_STAT_TYPE, statType);
      }
    });

    return {
      ...toRefs(dataMap),
    };
  }
})
